// extracted by mini-css-extract-plugin
module.exports = {"outline":"OutlineButton_outline__3Io8f","outline2":"OutlineButton_outline2__yzYpW"};